import { render } from "./TextEditorComponent.vue?vue&type=template&id=2e7dec25"
import script from "./TextEditorComponent.vue?vue&type=script&lang=js"
export * from "./TextEditorComponent.vue?vue&type=script&lang=js"

import "./TextEditorComponent.vue?vue&type=style&index=0&id=2e7dec25&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__